import { Component } from "react"
import PropTypes from "prop-types"
import { capitalize } from "humanize-plus"
import { fixedPercentValue } from "../lib"
import { logScaleHackFixer } from "../user_metrics/geo_fetcher"

export default class WorldMapChart extends Component {
  getSettings(props) {
    return {
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      chart: {
        map: "custom/world-according-to-ifttt",
        renderTo: this.chartContainer,
      },
      series: [
        {
          data: props.data,
          joinBy: ["iso-a2", "code"],
          name: `${capitalize(props.userType)} user count`,
          states: {
            hover: {
              color: "#BADA55",
            },
          },
          dataLabels: {
            enabled: false,
          },
        },
      ],
      tooltip: {
        formatter(tooltip) {
          return `<b>${this.point.name}</b><br>${capitalize(
            props.userType
          )} users: ${logScaleHackFixer(
            this.point.value
          )}<br>Total users in the ${props.categoryName} category: ${
            this.point.categoryTotal
          }<br>${props.serviceName} share: ${fixedPercentValue(
            this.point.value / this.point.categoryTotal
          )}%`
        },
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          verticalAlign: "bottom",
        },
      },
      colorAxis: { type: "logarithmic" },
      credits: { enabled: false },
    }
  }

  async componentDidMount() {
    const Highcharts = await import("highcharts/highmaps")
    await import("./world_map_data")

    this.chart = Highcharts.mapChart(this.getSettings(this.props))
  }

  componentWillUnmount() {
    if (this.chart) this.chart.destroy()
  }

  async shouldComponentUpdate(nextProps) {
    const Highcharts = await import("highcharts/highmaps")
    await import("./world_map_data")

    if (this.props.data !== nextProps.data) {
      if (this.chart) this.chart.destroy()
      this.chart = Highcharts.mapChart(this.getSettings(nextProps))
    }
    return false
  }

  render() {
    return (
      <div
        className="chart-container map-chart"
        ref={c => (this.chartContainer = c)}
      />
    )
  }
}

WorldMapChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  userType: PropTypes.string.isRequired,
  categoryName: PropTypes.string.isRequired,
  serviceName: PropTypes.string.isRequired,
}

WorldMapChart.defaultProps = {}
